module.exports = __webpack_public_path__ + "img/collection-memoireRingsConfigurator.4de0b17.jpg";